import React from "react";
import styled from "styled-components";
import PartialMap from "./PartialMap";
import PartialMarket from "./PartialMarket";
import FlexBox from "../../components/Shared/FlexBox";

/* -------------------- Styled Components -------------------- */
const PartialCover = styled(FlexBox)`
  width: 100%;
  img,
  picture {
    object-fit: cover;
    width: 100%;
    max-height: 800px;
  }
  ${FlexBox} {
  }

  @media (max-width: 767px) {
    margin-top: 10px;
  }
`;

const Container = styled.div`
  font-family: "Noto Serif TC", "Microsoft JhengHei", serif;
  background: #fffaf3;
  color: #3b2e1a;
  line-height: 1.8;
`;

const Section = styled.section`
  max-width: 900px;
  margin: 4rem auto;
  padding: 0 1.5rem;
  
  img {
    &[data-ref="logo"] {
      margin: 20px 0;
    }
  }
`;

const LogoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  img{
    margin: 20px;
    &[data-ref=logo-cpc]{
      width: 300px;
    }
    &[data-ref=logo-flavor]{
      width: 200px;
    }
  }
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;


const SectionTitle = styled.h3`
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: #8c5c2f;
  border-left: 6px solid #cfa66b;
  padding-left: 0.5rem;
`;

const Text = styled.p`
  margin-bottom: 1rem;
  font-size: 1.05rem;
`;

const Highlight = styled.span`
  color: #a36b2e;
  font-weight: 600;
`;

const InfoSection = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.5rem;
  max-width: 1000px;
  margin: 3rem auto;
  padding: 0 1.5rem;
`;

const InfoCard = styled.div`
  background: #fffdf8;
  border: 1px solid #e8d9c4;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 14px rgba(0, 0, 0, 0.08);
  }
`;

const CardTitle = styled.h4`
  color: #a36b2e;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
`;

const CardText = styled.p`
  font-size: 1rem;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 2rem 0;
  background: #fffdf8;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  th,
  td {
    padding: 1rem;
    border-bottom: 1px solid #f0e6d2;
    text-align: center;
    font-size: 1rem;
  }

  th {
    background: #f8ecd9;
    color: #7c5023;
    font-weight: 600;
  }

  tr:last-child td {
    border-bottom: none;
  }

  @media (max-width: 600px) {
    th,
    td {
      font-size: 0.9rem;
      padding: 0.8rem;
    }
  }
`;

const FloatingImg = styled.img`
  position: absolute;
  top: 50%;
  width: 180px;
  opacity: 0.9;
  animation: floatAnim 4s ease-in-out infinite;

  @keyframes floatAnim {
    0% { transform: translateY(-50%) translateY(0px); }
    50% { transform: translateY(-50%) translateY(-18px); }
    100% { transform: translateY(-50%) translateY(0px); }
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

const IntroWrapper = styled.div`
  position: relative;
`;


const Footer = styled.footer`
  text-align: center;
  padding: 2rem 1rem;
  font-size: 0.9rem;
  color: #7a6a50;
  border-top: 1px solid #e0d6c8;
  background: #fff8ef;
`;

const EbookWrapper = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 4rem auto;
  padding: 0 1.5rem;
  iframe {
    width: 100%;
    height: 600px;
    border: none;
  }

  @media (max-width: 767px) {
    iframe {
      height: 400px;
    }
  }
`;


const PageHome = () => {
  return (
    <Container>
      <PartialCover id="cover">
        <picture>
          <source
            media="(max-width: 767px)"
            srcSet={"https://i.meee.com.tw/UCNjOiH.jpg"}
          />
          <img src={"https://i.meee.com.tw/2QiXNCj.jpg"} alt="封面圖片" />
        </picture>
      </PartialCover>

      {/* 活動簡介 */}
      <Section id="intro">
        <IntroWrapper>
          {/* 左邊漂浮圖 */}
          <FloatingImg
            style={{ left: "-320px", top: '300px' }}
            src="https://i.meee.com.tw/sVwYDWu.png"
            alt="漂浮裝飾左"
          />

          {/* 右邊漂浮圖 */}
          <FloatingImg
            style={{ right: "-320px", top: '100px' }}
            src="https://i.meee.com.tw/IMykdJI.png"
            alt="漂浮裝飾右"
          />
          <SectionTitle>活動簡介</SectionTitle>
          <Text>
            暖香集結！本次活動匯聚 50+ 間橫跨北中南的頂級餐飲品牌與人氣名店，
            共同以「麻油」這項經典風味為靈感，創作出屬於台灣的暖香風景。
          </Text>
          <Text>
            從摘星的頂級宴客料理，到國際五星飯店中西式餐飲，以及精緻宴會餐飲，
            再到創新中菜、私廚，更有在地人氣麻油名店與主題咖啡熱情響應。
          </Text>
          <Text>
            《2025 麻油料理餐廳月》由
            <Highlight>經濟部商業發展署</Highlight> 策劃，
            邀請您從古早味補湯的溫暖記憶，到精緻餐桌上的創意驚喜，
            一起探索麻油風味的無限可能！
          </Text>
        </IntroWrapper>
      </Section>

      {/* 活動資訊卡 */}
      <InfoSection id="schedule">
        <InfoCard>
          <CardTitle>活動日期</CardTitle>
          <CardText>2025.11.14（五） - 2025.12.31（三）</CardText>
        </InfoCard>
        <InfoCard>
          <CardTitle>活動地點</CardTitle>
          <CardText>於各活動店家中舉行</CardText>
        </InfoCard>
        <InfoCard>
          <CardTitle>參與品牌</CardTitle>
          <CardText>
            集結 50+ 間橫跨北中南的知名餐飲品牌與人氣名店，從米其林一星宴會料理、
            精緻飯店餐飲、創新中式餐廳，到在地人氣小吃等。
          </CardText>
        </InfoCard>
      </InfoSection>

      <Section>

        <img src="https://i.meee.com.tw/PAQ1CxB.png" alt="經濟部" />
      </Section>

      {/* 消費者參與辦法 */}
      <Section>
        <SectionTitle>消費者參與辦法</SectionTitle>
        <Text>
          活動期間前往合作店家，即可享優惠方案購買指定品項之「麻油風味料理」。
          完成特別任務可再加碼獲得限量好禮或參加抽獎！
        </Text>
      </Section>

      {/* 優惠啟動時程 */}
      <Section>
        <IntroWrapper>
          {/* 左邊漂浮圖 */}
          <FloatingImg
            style={{ width: "250px", left: "-320px", top: '300px' }}
            src="https://i.meee.com.tw/AZrf3GG.png"
            alt="漂浮裝飾左"
          />

          {/* 右邊漂浮圖 */}
          <FloatingImg
            style={{ width: "210px", right: "-320px", top: '100px' }}
            src="https://i.meee.com.tw/9wf5Hfn.png"
            alt="漂浮裝飾右"
          />
          <SectionTitle>優惠啟動時程</SectionTitle>
          <Text>
            為了讓消費者能更彈性地規劃這趟暖香美食之旅，
            <Highlight>2025年的麻油料理餐廳月</Highlight>
            將分兩階段開放合作店家優惠：
          </Text>

          <Table>
            <thead>
              <tr>
                <th>階段</th>
                <th>開始日期</th>
                <th>結束日期</th>
                <th>說明</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>第一波（首波釋出品牌）</td>
                <td>2025年11月14日（五）</td>
                <td>2025年12月31日（三）</td>
                <td>14間精選合作店家</td>
              </tr>
              <tr>
                <td>第二波（43間合作店家）</td>
                <td>2025年11月25日（二）</td>
                <td>2025年12月31日（三）</td>
                <td>更多合作店家全面加入</td>
              </tr>
            </tbody>
          </Table>

          <Text>
            請持續關注官方網站及各合作店家公告，了解詳細的優惠內容、
            麻油限定料理與適用條件！
          </Text>
        </IntroWrapper>
      </Section>

      <Section id="ebook">
        <SectionTitle>電子書閱讀</SectionTitle>
        <EbookWrapper>
          <iframe
            src="https://www.tw-cuisine.tw/2025sesameoil/"
            title="電子書閱讀"
          />
        </EbookWrapper>
      </Section>


      {/* 抽獎辦法 */}
      <Section id="lottery">
        <SectionTitle>抽獎辦法</SectionTitle>
        <Text>
          消費者於活動期間前往合作店家除了可以優惠方案購買指定品項之「麻油風味料理」，
          完成特別任務可再加碼參加抽獎，現場拍下料理美照並將照片回文留言至「臺灣美食」FB的活動貼文中，
          留言範例：我在＠餐廳吃麻油料理＋上傳菜色照片
          就有機會抽中主辦單位加碼的麻油小禮（臺灣黑麻油禮盒）一罐，共10名！
        </Text>
        <Text>
          得獎名單將於1/09（五）於 #臺灣美食 Facebook 粉絲團中公布
          別忘了追蹤 ＠臺灣美食，隨時掌握中獎名單與暖胃消息！
        </Text>
        <img
          src="https://i.meee.com.tw/OswsY6F.jpg"
          alt="抽獎獎品：臺灣黑麻油禮盒"
          style={{ display: "block", margin: "1rem auto", maxWidth: "300px" }}
        />
      </Section>


      <PartialMarket />
      <PartialMap />

      {/* 主辦單位 */}
      <Section>
        <SectionTitle>主辦單位</SectionTitle>
        <Text>
          <Highlight>經濟部商業發展署</Highlight> — 以推動商業服務業發展及優化公司治理環境為主軸，
          致力協助我國服務業提升軟實力及科技力，推動品牌海外輸出、活絡內需市場，
          並落實數位化國家政策，營造企業開辦友善環境。
        </Text>
        <img data-ref="logo" src={"https://i.meee.com.tw/uJ5oNXx.png"} alt="經濟部商業發展署" />
      </Section>

      <Section>
        <SectionTitle>執行單位</SectionTitle>

        <LogoRow>
          <img data-ref="logo-cpc" src={"https://i.meee.com.tw/qXq8Qvv.png"} alt="CPC" />
          <img data-ref="logo-flavor" src={"https://i.meee.com.tw/TgAwDXC.png"} alt="flavor" />
        </LogoRow>
      </Section>


      <Footer>© 2025 麻油料理餐廳月 | 經濟部商業發展署</Footer>
    </Container>
  );
};

export default PageHome;
